import { Link } from 'react-router';
import { Card } from '@heroui/react';

/**
 * PRD section 5.4: "a plain 'not a member' error page, no session issued".
 *
 * Kept deliberately uninformative — it names no group, no admin and no
 * @username, and offers no way to request access. What it does state is the
 * part a visitor can act on and that costs nothing to reveal: the remedy is to
 * be added to the group, and because membership is re-checked live on every
 * request (PRD §5.6) access returns on the next one, with no second sign-in.
 * The copy is deliberately not phrased as a rejection — the same distinction
 * `RequireMember` draws for `unavailable` — because nothing here is the
 * visitor's mistake.
 *
 * TODO(OPEN-ITEM-D): should this tell the visitor how to ask for access
 * (a link, an @username), or stay as it is? See docs/OPEN_ITEMS.md.
 */
export function NotAMemberPage() {
  return (
    // The centring wrapper is a copy of `Centered` in components/guards.tsx —
    // the three standalone pages (sign-in, this one, not-found) render outside
    // AppShell and have to line up with the guard screens the router shows in
    // their place.
    <div className="grid min-h-dvh place-items-center bg-background px-4 py-6 text-foreground">
      <Card className="w-full max-w-md">
        <Card.Header>
          <Card.Title className="text-xl">Аккаунт не в группе</Card.Title>
          <Card.Description>
            Этот Telegram-аккаунт не состоит в группе, к которой привязано приложение.
          </Card.Description>
        </Card.Header>

        <Card.Content className="flex flex-col gap-4">
          <p className="text-sm text-muted">
            Доступ откроется, как только аккаунт добавят в группу: членство проверяется при каждом
            запросе, поэтому входить заново не понадобится.
          </p>
          <Link to="/login" className="text-sm text-link underline underline-offset-2">
            Вернуться ко входу
          </Link>
        </Card.Content>
      </Card>
    </div>
  );
}
